var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServAddInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 504,
    height: 239,
    viewBox: "0 0 504 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1.99999 252C1.99998 390.071 113.929 502 252 502C390.071 502 502 390.071 502 252M1.99999 252C2 113.929 113.929 2.00011 252 2.00011C390.071 2.00012 502 113.929 502 252M1.99999 252C1.99999 321.036 57.9646 377 127 377C196.036 377 252 321.036 252 252M1.99999 252C1.99999 182.965 57.9646 127 127 127C196.036 127 252 182.965 252 252M502 252C502 182.965 446.036 127 377 127C307.965 127 252 182.965 252 252M502 252C502 321.036 446.036 377 377 377C307.965 377 252 321.036 252 252",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M252 252C252 321.036 307.965 377 377 377C446.036 377 502 321.036 502 252C502 182.965 446.036 127 377 127C307.965 127 252 182.965 252 252ZM252 252C252 182.965 196.036 127 127 127C57.9647 127 2 182.964 1.99999 252C1.99999 321.036 57.9646 377 127 377C196.036 377 252 321.036 252 252Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServAddInformation);
export default __webpack_public_path__ + "static/media/serv-add-information.b7bb59a80d91b4b6ee0e3758884b564d.svg";
export { ForwardRef as ReactComponent };